<template>
    <div class="zuke_index">
        <div class="footer_box">
            <div class="footer_fixed">
                <div class="footer">
                    <div class="footer_list" @click="footer_btn('/baike')">
                        <img v-if="result == 'baike'" class="footer_img active" src="../../assets/images/index_on.png">
                        <img v-if="result != 'baike'" class="footer_img" src="../../assets/images/index.png">
                        <div class="footer_title">首页</div>
                    </div>
                    <div class="footer_list" @click="footer_btn('/baike/guide')">
                        <img class="footer_img" src="../../assets/images/add.png">
                        <div class="footer_title">创建词条</div>
                    </div>
                    <div class="footer_list" @click="footer_btn('/baike/personal')">
                        <img v-if="result == 'personal'" class="footer_img" src="../../assets/images/my_on.png">
                        <img v-if="result != 'personal'" class="footer_img" src="../../assets/images/my.png">
                        <div class="footer_title">我的</div>
                    </div>
                </div>
            </div>
        </div>
        <PasswordPop ref="mychild" :passwordPop="passwordPop"></PasswordPop>
    </div>
</template>

<script>
    import PasswordPop from '../../components/passwordPop/passwordPop.vue';
    export default {
        name: "footerBox",
        data:()=>{
            return {
                passwordPop:{
                    isPassword: false,          //是否显示弹框
                    type: 'job',                   //类型
                    getUrl: 'sanfang',          //登录完成跳转路径
                    zkhBay:'',                  //保存number
                },
            }
        },
        methods:{
            footer_btn(url){
                if(this.$publicObj.getCookie('is_login') && this.$publicObj.getCookie('member_id') && this.$publicObj.getCookie('member_pass')){
                    this.$router.push({
                        path:url
                    })
                }
                this.passwordPop.type = 'jobs';
                // 判断是否登录了
                this.$refs.mychild.getIsLogin()
            }
        },
        mounted() {
            
            
        },
        components:{
            PasswordPop
        },
        // 计算属性
        computed: {
            result: function() {
                // console.dir(this.$route.path)
                // 把路由（字符串）分割成数组
                var arr = this.$route.path.split('/');
                //  把路由的名称 return
                // console.log(arr[arr.length-1]);
                return arr[arr.length-1];
            }
        }
    }
</script>

<style scoped>
    .footer_box {
        height: 2.133333rem;
    }
    
    .footer_fixed {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2.133333rem;
        z-index: 100;
        box-shadow:0px -2px 7px 0px rgba(245,245,245,1);
    }
    
    .footer {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        height: 2.133333rem;
        margin: 0 auto;
        background-color: #fff;
    }
    
    .footer_list {
        flex: 1;
        text-align: center;
    }
    
    .footer_img {
        width: 0.896rem;
    }
    
    .footer_title {
        color: #999;
        font-size: 0.469333rem;
    }
    
</style>


// WEBPACK FOOTER //
// footerBox.vue